import { useMemo } from 'react';
import { useRoomContext } from 'contexts/RoomContext';

/**
 * Wraps useRoomContext and filters systemDropdownValues & singleEntryField
 * by the given clientId.
 *
 * Options with no clients assigned (global) are always included.
 * Options assigned to the given clientId are included.
 * Options assigned to other clients only are excluded.
 */
export const useFilteredRoomContext = (clientId?: string | number) => {
  const context = useRoomContext();

  const systemDropdownValues = useMemo(() => {
    if (!context.systemDropdownValues || !clientId) return context.systemDropdownValues;
    return context.systemDropdownValues.filter((option) => {
      const clients = option.dropdownOptionClients;
      if (!clients || clients.length === 0) return true;
      return clients.some((c) => String(c.clientId) === String(clientId));
    });
  }, [context.systemDropdownValues, clientId]);

  const singleEntryField = useMemo(() => {
    if (!context.singleEntryField || !clientId) return context.singleEntryField;
    return context.singleEntryField.filter((field) => {
      const clients = field.singleDataEntryClients;
      if (!clients || clients.length === 0) return true;
      return clients.some((c) => String(c.clientId) === String(clientId));
    });
  }, [context.singleEntryField, clientId]);
  return {
    ...context,
    systemDropdownValues,
    singleEntryField
  };
};
